import { render } from "./ParentNode.vue?vue&type=template&id=3d4a7ce2&scoped=true"
import script from "./ParentNode.vue?vue&type=script&lang=js"
export * from "./ParentNode.vue?vue&type=script&lang=js"

import "./ParentNode.vue?vue&type=style&index=0&id=3d4a7ce2&scoped=true&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4a7ce2"]])

export default __exports__